<div class="full-width-image-container">
    <img src="../../assets/AdobeStock_3558442.jpeg" alt="Header Image">
  </div>

<div class="top">
    <div>Do The <span>Right Thing</span></div>
    <div>On Point <span>With Safety</span></div>
    <div>Roll up <span>Your Sleeves</span></div>
</div>
    <hr class="hr">
    <br><br><br>

    
    <div class="page-title">
        <h1 class="title-text">JSA Forms</h1>
    </div>
    <div class="button-group">
        <div class="button-container">
            <div class="button-title">JSA Digital Submissions</div>
            <a mat-raised-button routerLink="/jsa" routerLinkActive="active" color="primary">View Form</a>
        </div>
        <div class="button-container">
            <div class="button-title">JSA Paper Submission</div>
            <a mat-raised-button routerLink="/jsa-paper" routerLinkActive="active" color="primary">View Form</a>
        </div>
    </div>
    <div class="button-group">
        <div class="button-container">
            <div class="button-title">Safety Applications</div>
            <a mat-raised-button routerLink="/app-hub" routerLinkActive="active" color="primary">Go to Apps</a>
        </div>
        <div class="button-container">
            <div class="button-title">Blank Paper JSA</div>
            @if (blankJsaLoading) {
              <div class="spinner-container"><mat-spinner diameter="24"></mat-spinner></div>
            } @else if (blankJsaUrl) {
              <a mat-raised-button color="primary" [href]="blankJsaUrl" target="_blank">Download Form</a>
            }
        </div>
    </div>
    <br><br><br><br>
    <div class="page-title">
        <h1 class="title-text">Additional Safety Forms</h1>
    </div>
    <div class="button-group">
        <div class="button-container">
            <div class="button-title">Near Miss</div>
            <a mat-raised-button routerLink="/miss" routerLinkActive="active" color="primary">View Form</a>
        </div>
        <div class="button-container">
            <div class="button-title">Good Catch</div>
            <a mat-raised-button routerLink="/catch" routerLinkActive="active" color="primary">View Form</a>
        </div>
    </div>
    <div class="button-group">
        <div class="button-container">
            <div class="button-title">Accident Report</div>
            <p class="note">Landpoint is now using Fleetio for accident report submissions. Click below to be taken to Fleetio.</p>
            <a class="fleetio-button" href="https://secure.fleetio.com/a8b7f52a3f/inspection_forms?page=1&per=50&q[s]=title+asc" target="_blank" rel="noopener">
                <img src="../../assets/fleetio-logo.png" alt="Fleetio" class="fleetio-logo">
            </a>
        </div>
    </div>
    <div class="button-group">
        <div class="button-container">
            <div class="button-title">First Aid Report</div>
            <a mat-raised-button routerLink="/first-aid-form" routerLinkActive="active" color="primary">View Form</a>
        </div>
       <div class="button-container">
            <div class="button-title">Blank First Aid Report</div>
            @if (blankFirstAidLoading) {
              <div class="spinner-container"><mat-spinner diameter="24"></mat-spinner></div>
            } @else if (blankFirstAidUrl) {
              <a mat-raised-button color="primary" [href]="blankFirstAidUrl" download>Download Form</a>
            }
        </div>
    </div>
<br><br><br><br>

<div class="dev-msg">
    <div class="button-title">Safety Handbook</div>
    <p class="dev-p">
        @if (safetyHandbookLoading) {
          <div class="spinner-container"><mat-spinner diameter="24"></mat-spinner></div>
        } @else if (safetyHandbookUrl) {
          <a mat-raised-button [href]="safetyHandbookUrl" target="_blank" color="primary">View Handbook</a><br>
        }
    </p>
</div>


